import { creacionDivBotones } from "./botones";
import { creacionDivLeyenda } from "./leyenda";
import { creacionDivOpacidad } from "./opacidad";
import { creacionDivTitulo } from "./titulo";

// funcion que actualiza en numero de capas activas
function updateChildCount() {
  const container = document.querySelector(".contenedor-capas-activas");
  const button = document.querySelector(".boton-capas-activas");

  // Count the number of children inside .contenedor-capas-activas
  const childCount = container.children.length;

  // If there are children, create or update the count circle
  let countCircle = button.querySelector(".count-circle");

  if (!countCircle) {
    countCircle = document.createElement("div");
    countCircle.classList.add("count-circle");
    button.appendChild(countCircle);
  }

  // Set the text content of the circle to the child count
  if (childCount >= 1) {
    countCircle.textContent = childCount;
  } else {
    countCircle.classList.remove("count-circle");
    countCircle.textContent = "";
  }
}

const capaActiva = (layer, view, uid) => {
  //necesito la capa para acceder a los atributos
  //console.log('uid, ',uid)

  const layerName = layer.get("title") || "Sin título";

  const layerSource = layer.getSource();

  //nombre poblacion_por_censo_2022
  const nombreCapa = layerSource.getParams().LAYERS;

  let contenedorCapa = document.getElementById(nombreCapa);

  //crea la legenda si no existe
  if (!contenedorCapa) {
    const container = document.querySelector(".contenedor-capas-activas");

    const childCount = container.children.length;
    //set Z Index en base al contador (funciona)
    layer.setZIndex(childCount);

    //div contenedor de la capa
    contenedorCapa = document.createElement("div");
    contenedorCapa.id = nombreCapa;
    contenedorCapa.draggable = true;
    contenedorCapa.className = "capas-activas-panel";
    contenedorCapa.setAttribute("data-layer-id", uid);

    const contenedorCapasActivas = document.querySelector(
      ".contenedor-capas-activas"
    );

    //inserta antes del primer elemento del elemento padre (contenedor)
    // inserta como primer item
    contenedorCapasActivas.insertBefore(
      contenedorCapa,
      contenedorCapasActivas.firstChild
    );

    updateChildCount();

    //se agregan los div al contenedorCapa
    creacionDivLeyenda(contenedorCapa, layerSource, layerName, view);
    creacionDivOpacidad(contenedorCapa, layer);
    creacionDivTitulo(contenedorCapa, layerName);
    creacionDivBotones(contenedorCapa, layer, layerName, view);
  }
};

const removeLegend = function (nombreCapa) {
  const contendorDentro = document.getElementById(nombreCapa);

  if (contendorDentro) {
    //elimina el elemento
    contendorDentro.remove();
    //Sacar cuenta
    updateChildCount();
  }
};

export { capaActiva, removeLegend };
